import axiosInstance from "@/services/axiosInterceptor";

export async function updateUserAvailability(body) {
  try {
    const response = await axiosInstance.patch(`users/availability`, body);
    const data = response?.data;
    return data;
  } catch (error) {
    throw error;
  }
}

export async function updateUserUnavailability(body, action) {
  try {
    const response = await axiosInstance.patch(`users/unavailability?action=${action}`, body);
    const data = response?.data;
    return data;
  } catch (error) {
    throw error;
  }
}
